import * as S from './styles';
import SideBarLogo from '../../../../components/NavBar/Sidebar/SideBarLogo';
import SideBarOptions from '../../../../utils/SideBarOptions';
import { SidebarItem } from '../../../../components/NavBar/Sidebar/SidebarItem';

import { useLocation } from 'react-router-dom';
import { useSidebar } from '../../../../utils/context/sidebarContext';
import { connectUtil, PropsFromRedux } from '../../../../utils/reduxUtil';
import { RootStateBase } from '../../../../store/baseStore';

interface Props extends PropsFromRedux<typeof connector> {
 options: Array<SideBarOptions>,
}

const connector = connectUtil(
  (state: RootStateBase) => ({
    conditionalRoute: state.UtilReducer.ConditionalRoute,
  }),
  { }
);


export function Sidebar ({ options, conditionalRoute }: Props)  {
  const { collapsed, toggleCollapsed } = useSidebar();
  const location = useLocation();

  return (
    <S.Container open={collapsed}>
      <S.NavContainer>
        <SideBarLogo onClick={toggleCollapsed} open={collapsed} />
        <S.OptionsContainer>
          {
            options.map((i, k) => {
              const isActive = (location.pathname === i.LinkTo);

              const routePath = i.LinkTo.replace('/', '');
              const routeState = conditionalRoute.find(cr => cr.Path === routePath);
              const isRouteEnabled = routeState ? routeState.Status !== false : true;

              if (!isRouteEnabled) {
                return null;
              }
              return (
                <SidebarItem 
                  key={k} 
                  isCurrentRoute={isActive} 
                  linkTo={i.LinkTo} 
                  iconName={i.Icon} 
                  open={collapsed}
                >
                  {i.Title}
                </SidebarItem>
              );
            })
          }
        </S.OptionsContainer>
      </S.NavContainer>
    </S.Container>
  )
}

export default connector(Sidebar);

